import { Component } from 'react';

import { getCountries } from '~/api/geo';

import Select from 'Lib/components/form/Select';
import withContainer from '../hoc/withContainer';
import { LOADING } from 'Lib/constants/app/commonConstants';

const mapApiToProps = {
    getCountries
};

class CountrySelect extends Component {
	state = {
		countries: []
	}

    componentDidMount() {
		this.props.handlePromises(this.props.api.getCountries())
			.then(response => {
				this.setState({
					countries: response.data
				})
			});
    }

    render() {
		const { countries } = this.state;
        const { value, ...rest } = this.props;

        if (!countries) {
            return <Select placeholder={LOADING} />;
        }

        const options = countries.map(({ country }) => ({ label: country.countryName, value: country.countryID }));

        return <Select {...rest} options={options} value={value} clearable={true} />;
    }
}

export default withContainer(CountrySelect, mapApiToProps);
